<template>
  <div>
    <div class="header-single header-desp">
      <div class="container  h-100">
        <div class="row align-items-end  h-100">
          <div class="col-sm ">
            <h1 class="align-bottom">{{ $t('pescaDesportivaInstitucional.titulo') }}</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="container pt-5">
      <div class="row">
        <div class="col-md-4 p-3 ">

          <p class="mt-5">{{ $t('pescaDesportivaInstitucional.paragrafo1') }}</p>

        </div>
        <div class="col-md-4 p-3">

          <p class="mt-5">{{ $t('pescaDesportivaInstitucional.paragrafo2') }}</p>

          <p>{{ $t('pescaDesportivaInstitucional.paragrafo3') }}</p>

          <p><a href="https://institutohorus.org.br/wp-content/uploads/2019/03/2016-FATMA-Pets-ornamentais-pesca-desportiva-low-res.pdf" target="_blank">{{ $t('pescaDesportivaInstitucional.paragrafo7') }}</a>.</p>

        </div>
        <div class="col-md-4 p-3">
          <!-- galeria -->
            <div id="carousel-especies" class="carousel slide" data-bs-ride="carousel">
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <img src="../../../assets/institucional/img/galeria/galeria-desportiva-1.jpg" class="d-block w-100" alt="...">
                  <div class="carousel-caption d-none d-md-block">
                    <p class="text-start">
                      {{ $t('pescaDesportivaInstitucional.paragrafo4') }}<br>{{ $t('pescaDesportivaInstitucional.paragrafo4b') }}
                    </p>
                  </div>
                </div>
                <div class="carousel-item ">
                  <img src="../../../assets/institucional/img/galeria/galeria-desportiva-2.jpg" class="d-block w-100" alt="...">
                  <div class="carousel-caption d-none d-md-block">
                    <p class="text-start">
                      {{ $t('pescaDesportivaInstitucional.paragrafo5') }}<br>{{ $t('pescaDesportivaInstitucional.paragrafo5b') }}
                    </p>
                  </div>
                </div>
                <div class="carousel-item ">
                  <img src="../../../assets/institucional/img/galeria/galeria-desportiva-3.jpg" class="d-block w-100" alt="...">
                  <div class="carousel-caption d-none d-md-block">
                    <p class="text-start">
                      {{ $t('pescaDesportivaInstitucional.paragrafo6') }}<br>{{ $t('pescaDesportivaInstitucional.paragrafo6b') }}
                    </p>
                  </div>
                </div>
              </div>
              <button class="carousel-control-prev" type="button" data-bs-target="#carousel-especies" data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">{{ $t('label.anterior') }}</span>
              </button>
              <button class="carousel-control-next" type="button" data-bs-target="#carousel-especies" data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">{{ $t('label.próximo') }}</span>
              </button>
            </div><!--/ galeria -->
        </div>
      </div>
      <EspeciesForm v-if="viewEspecie" :speciesId="species.species_id" :viewEspecie="true" :byInstitucional="true"/>
      <Especies v-else :withFilter="false" :withPageTitle="false" :withOrderBy="true" :byInstitucional="true" @actionByInstitucional="actionByInstitucional" :dataFilter="{ species_type: 1, kingdom_id: 1, economic_use_id: 17, class_id: 1 }"/>
      <div class="row mb-2 mb-xl-3">
        <div class="col-auto ml-auto text-right mt-n1">
          <button v-if="viewEspecie" @click="viewEspecie=false" class="btn bt-filtrar mt-1 mb-2">
            {{ $t('label.exibirListagem') }}
          </button>
        </div>
      </div>
      <InstitucionalSliderTemas />
    </div>
  </div>
</template>

<script>
import Especies from '../../admin/especies/Especies.vue'
import EspeciesForm from '../../admin/especies/EspeciesForm.vue'
import InstitucionalSliderTemas from '@/components/institucional/InstitucionalSliderTemas'
export default {
  name: 'PescaDesportivaInstitucional',
  components: { Especies, EspeciesForm, InstitucionalSliderTemas },
  data () {
    return {
      driver: null,
      viewEspecie: false,
      species: {}
    }
  },
  methods: {
    actionByInstitucional: function (item) {
      this.species = item
      this.viewEspecie = true
    }
  },
  created () {
    this.viewEspecie = false
  }
}
</script>
